<h2 mat-dialog-title>Nova Senha</h2>
<form [formGroup]="form" class="example-form" (submit)="confirmNewPassword()">
  <mat-dialog-content class="mat-typography">
    <page-alert *ngIf="submittedCode && successSubmited" message="Código enviado ao E-mail: {{ this.email }}"
      alertClass="alert-success"></page-alert>
    <page-alert *ngIf="submittedCode && !successSubmited" message="Falha enviar código!"
      alertClass="alert-danger"></page-alert>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Código</mat-label>
      <input type="text" matInput formControlName="code" placeholder="Código" />
      <mat-error *ngIf="form.get('code')?.hasError('code')"> - Código inválido. </mat-error>
      <mat-error *ngIf="form.get('code')?.hasError('required')">Informe o código.</mat-error>
    </mat-form-field>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Nova senha</mat-label>


      <input [type]="hide ? 'password' : 'text'" matInput formControlName="newPassword" placeholder="Nova senha" />
      <button  type="button" class="icon-button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Esconder Senha'"
        [attr.aria-pressed]="hide">
        <mat-icon matSuffix>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error *ngIf="form.get('newPassword')?.hasError('newPassword')"> - Insira uma senha válida. </mat-error>
      <mat-error *ngIf="form.get('newPassword')?.hasError('invalidPassword')">
        A senha deve conter pelo menos 1 número, 1 letra maiúscula, 1 letra minúscula e caracteres especiais.
      </mat-error>

      <mat-error *ngIf="form.get('newPassword')?.hasError('required')"> A senha é obrigatória. </mat-error>
    </mat-form-field>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Confirmar senha</mat-label>
      <input [type]="hide ? 'password' : 'text'" matInput formControlName="confirmPassword" placeholder="Nova senha" />
      <button  type="button" class="icon-button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Esconder Senha'"
        [attr.aria-pressed]="hide">
        <mat-icon matSuffix>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')"> A confirmação da senha é
        obrigatória.</mat-error>
      <mat-error *ngIf="form.hasError('mismatch')"> As senhas não coincidem. </mat-error>

    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">

    <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
    <button  [disabled]="form.invalid" mat-flat-button color="primary" type="submit">Redefinir senha</button>
  </mat-dialog-actions>
</form>